export const ATTRIBUTION_STORAGE_KEY = 'checkout_attribution:v1';

/** Afilio's GTM template reads these from localStorage before its cookies. */
const AFILIO_STORAGE_KEYS = ['afclick', 'aforigin'];

/** localStorage keys that must survive the session-expiry storage wipe. */
export const SESSION_CLEAR_PRESERVED_KEYS = [
  ATTRIBUTION_STORAGE_KEY,
  ...AFILIO_STORAGE_KEYS,
];
